module.exports = __webpack_public_path__ + "static/logos-a66f9a0ca670ab289c2809b0cde9fc4c.png";